var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"action":`/desk-audits/${_vm.deskAudit.id}`,"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"submit"}},[_vm._v("Remove Desk Audit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }